export type ParseEntityDataResult = Array<{
  path: string;
  data: unknown;
}>;

export const parseEntityData = (
  data: any,
  translate: (args: { id: string }) => string = () => '',
  parentPath = '',
) => {
  let result: ParseEntityDataResult = [];

  Object.keys(data ?? {}).forEach((key) => {
    const currentPath = parentPath ? `${parentPath}.${key}` : key;

    if (typeof data[key] === 'object' && data[key] !== null) {
      result = result.concat(
        parseEntityData(data[key], translate, currentPath),
      );
    } else {
      const rowData = typeof data[key] !== 'object' ? `${data[key]}` : '';
      result.push({ path: currentPath, data: rowData });
    }
  });

  return result;
};
